import React from 'react';
import { Link } from 'react-router-dom';
import { NOT_FOUND, useDocumentHead } from '../../seo/documentHead';

/**
 * Catch-all route. CloudFront already answers unknown URLs with a real 404
 * status; this covers in-app navigation to a path that doesn't exist.
 */
const NotFoundPage: React.FC = () => {
  useDocumentHead({ title: NOT_FOUND.title, description: NOT_FOUND.description, noindex: true });

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-8 text-center">
          <h1 className="display-5 mb-3">{NOT_FOUND.h1}</h1>
          <p className="lead mb-4">{NOT_FOUND.intro}</p>
          <div className="d-grid gap-3 d-sm-flex justify-content-center mb-5">
            <Link to="/" className="btn btn-primary btn-lg px-4">Go to the Home Page</Link>
            <Link to="/notes" className="btn btn-outline-primary btn-lg px-4">Browse Notes</Link>
            <Link to="/submit" className="btn btn-outline-primary btn-lg px-4">Write a Note</Link>
          </div>
          <p className="mb-0">
            If you are struggling with thoughts of suicide, call or text{' '}
            <a href="tel:988" className="fw-bold">988</a> to reach the Suicide and Crisis Lifeline, available 24/7.
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
